import { getFeaturedGameBoxGateway } from '@maxpreps/shared/data/ghost-apis/gateways-api';
import { getCurrentAndOpponentTeams } from '@maxpreps/shared/functions/utils/contestUtils';

const fetchFeaturedGame = async (teamId, ssid) => {
  const [data, error] = await getFeaturedGameBoxGateway(teamId, ssid);

  // This endpoint returns a 200 even when no valid next game box data is found
  if (error || !data) {
    return null;
  }

  const { contest, calculatedFields, videos, nfhsData, tournament } =
    data as any;

  const { currentTeam, opponentTeam } = getCurrentAndOpponentTeams(
    contest.teams,
    teamId,
    calculatedFields.teamsCalculated
  );

  return {
    contest: {
      ...contest,
      ...calculatedFields,
      currentTeam,
      opponentTeam
    },
    videos,
    nfhsData,
    tournament
  };
};

export default fetchFeaturedGame;
